const cards = Array.from(document.querySelectorAll(".vote-card"));
const dots = Array.from(document.querySelectorAll(".carousel-dots button"));
const prev = document.querySelector(".carousel-arrow-prev");
const next = document.querySelector(".carousel-arrow-next");
const reviewsTrack = document.querySelector(".reviews-track");
const reviewCards = Array.from(document.querySelectorAll(".reviews-carousel .review"));
const reviewsDots = document.querySelector(".reviews-dots");
const reviewsPrev = document.querySelector(".reviews-arrow-prev");
const reviewsNext = document.querySelector(".reviews-arrow-next");
let page = 0;
let reviewPage = 0;
let reviewsTimer;

function pad(value) {
  return String(value).padStart(2, "0");
}

function parseDropDate(dateValue, timeValue) {
  if (!dateValue || !timeValue) return NaN;
  const dateMatch = String(dateValue).trim().match(/^(\d{2})-(\d{2})-(\d{4})$/);
  const timeMatch = String(timeValue).trim().replace(":", ".").match(/^(\d{1,2})\.(\d{2})$/);
  if (!dateMatch || !timeMatch) return NaN;
  const day = Number(dateMatch[1]);
  const month = Number(dateMatch[2]) - 1;
  const year = Number(dateMatch[3]);
  const hour = Number(timeMatch[1]);
  const minute = Number(timeMatch[2]);
  if (hour > 23 || minute > 59) return NaN;
  return new Date(year, month, day, hour, minute, 0).getTime();
}

document.querySelectorAll("[data-countdown-hours]").forEach((countdown) => {
  const hours = Number(countdown.dataset.countdownHours) || 36;
  const tick = () => {
    const now = Date.now();
    const fixedStart = countdown.dataset.countdownStart ? Date.parse(countdown.dataset.countdownStart) : NaN;
    const fixedEnd = countdown.dataset.countdownEnd ? Date.parse(countdown.dataset.countdownEnd) : NaN;
    const title = countdown.closest(".product-countdown")?.querySelector("[data-countdown-title]");
    let target = Number.isNaN(fixedEnd) ? now + hours * 60 * 60 * 1000 : fixedEnd;
    if (!Number.isNaN(fixedStart) && now < fixedStart) {
      target = fixedStart;
      if (title) title.textContent = "Il drop inizia tra";
    } else if (!Number.isNaN(fixedEnd)) {
      if (title) title.textContent = now <= fixedEnd ? "Il drop termina tra" : "Drop terminato";
    }
    const distance = Math.max(target - Date.now(), 0);
    countdown.querySelector("[data-days]").textContent = pad(Math.floor(distance / 86400000));
    countdown.querySelector("[data-hours]").textContent = pad(Math.floor(distance / 3600000) % 24);
    countdown.querySelector("[data-minutes]").textContent = pad(Math.floor(distance / 60000) % 60);
    countdown.querySelector("[data-seconds]").textContent = pad(Math.floor(distance / 1000) % 60);
  };
  tick();
  setInterval(() => {
    tick();
  }, 1000);
});

document.querySelectorAll("[data-countdown-date-mode]").forEach((countdown) => {
  const title = countdown.closest(".product-countdown")?.querySelector("[data-countdown-title]");
  const panelLabel = countdown.closest(".drop-panel")?.querySelector(".panel-label");
  const tick = () => {
    const now = Date.now();
    const start = parseDropDate(countdown.dataset.countdownStartDate, countdown.dataset.countdownStartTime);
    const end = parseDropDate(countdown.dataset.countdownEndDate, countdown.dataset.countdownEndTime);
    let target = end;
    if (!Number.isNaN(start) && now < start) {
      target = start;
      if (title) title.textContent = "Il drop inizia tra";
      if (panelLabel) panelLabel.textContent = "Il drop inizia tra";
    } else if (!Number.isNaN(end)) {
      if (title) title.textContent = now <= end ? "Il drop termina tra" : "Drop terminato";
      if (panelLabel) panelLabel.textContent = now <= end ? "Il drop termina tra" : "Drop terminato";
    }
    if (Number.isNaN(target)) return;
    const distance = Math.max(target - now, 0);
    countdown.querySelector("[data-days]").textContent = pad(Math.floor(distance / 86400000));
    countdown.querySelector("[data-hours]").textContent = pad(Math.floor(distance / 3600000) % 24);
    countdown.querySelector("[data-minutes]").textContent = pad(Math.floor(distance / 60000) % 60);
    countdown.querySelector("[data-seconds]").textContent = pad(Math.floor(distance / 1000) % 60);
  };
  tick();
  setInterval(tick, 1000);
});

document.querySelectorAll("[data-drop-window]").forEach((section) => {
  const start = parseDropDate(section.dataset.dropStartDate, section.dataset.dropStartTime);
  const end = parseDropDate(section.dataset.dropEndDate, section.dataset.dropEndTime);
  const status = section.querySelector("[data-drop-status]");
  const buttons = section.querySelectorAll(".buy-button");
  const update = () => {
    const now = Date.now();
    const before = !Number.isNaN(start) && now < start;
    const after = !Number.isNaN(end) && now > end;
    buttons.forEach((button) => {
      button.disabled = before || after;
    });
    if (status) {
      status.textContent = before
        ? "Il prodotto sara acquistabile dalla data di inizio drop."
        : after
          ? "Drop terminato. Il prodotto non e piu acquistabile."
          : "Drop attivo. Il prodotto e acquistabile ora.";
    }
    if (after && !Number.isNaN(end)) {
      const reloadKey = `rarely-drop-reloaded-${end}`;
      if (!sessionStorage.getItem(reloadKey)) {
        sessionStorage.setItem(reloadKey, "1");
        window.setTimeout(() => window.location.reload(), 900);
      }
    }
  };
  update();
  setInterval(update, 1000);
});

document.querySelectorAll("[data-quantity-action]").forEach((button) => {
  button.addEventListener("click", () => {
    const input = button.closest(".quantity-stepper").querySelector("[data-quantity-input]");
    const direction = button.dataset.quantityAction === "increase" ? 1 : -1;
    input.value = Math.min(Math.max((Number(input.value) || 1) + direction, 1), 9);
  });
});

document.querySelectorAll("[data-product-gallery]").forEach((gallery) => {
  const panels = Array.from(gallery.querySelectorAll("[data-gallery-panel]"));
  const thumbs = Array.from(gallery.querySelectorAll("[data-gallery-thumb]"));

  function showGalleryPanel(index) {
    panels.forEach((panel) => panel.classList.toggle("is-active", panel.dataset.galleryPanel === String(index)));
    thumbs.forEach((item) => item.classList.toggle("is-active", item.dataset.galleryThumb === String(index)));
  }

  thumbs.forEach((thumb) => {
    thumb.addEventListener("click", () => {
      const index = thumb.dataset.galleryThumb;
      showGalleryPanel(index);
    });
  });

  if (gallery.dataset.galleryAutoplay === "true" && panels.length > 1) {
    let currentIndex = 0;
    window.setInterval(() => {
      currentIndex = (currentIndex + 1) % panels.length;
      showGalleryPanel(currentIndex);
    }, 4200);
  }
});

document.querySelectorAll(".deal-form").forEach((form) => {
  const fileInput = form.querySelector("[data-min-files]");
  const message = form.querySelector("[data-deal-form-message]");
  form.addEventListener("submit", (event) => {
    if (!fileInput) return;
    const minimum = Number(fileInput.dataset.minFiles) || 2;
    if (fileInput.files.length < minimum) {
      event.preventDefault();
      const text = `Carica almeno ${minimum} foto del prodotto. Puoi aggiungerne anche di piu.`;
      fileInput.setCustomValidity(text);
      fileInput.reportValidity();
      if (message) message.textContent = text;
      return;
    }
    fileInput.setCustomValidity("");
  });
});

function renderVotes() {
  const start = page * 4;
  cards.forEach((card, index) => card.classList.toggle("is-visible", index >= start && index < start + 4));
  dots.forEach((dot, index) => dot.classList.toggle("is-active", index === page));
}

document.querySelectorAll("[data-vote-button]").forEach((button) => {
  button.addEventListener("click", () => {
    const section = button.closest("[data-vote-section]");
    const customerId = section.dataset.customerId;
    if (!customerId) return;
    const card = button.closest(".vote-card");
    const key = `rarely-vote-${customerId}-${card.dataset.category}`;
    if (localStorage.getItem(key)) return;
    const count = card.querySelector(".vote-count");
    count.textContent = (Number(count.textContent.replace(/\./g, "")) + 1).toLocaleString("it-IT");
    localStorage.setItem(key, "1");
    button.textContent = "Votato";
    button.disabled = true;
  });
});

prev?.addEventListener("click", () => { page = page === 0 ? 1 : 0; renderVotes(); });
next?.addEventListener("click", () => { page = page === 1 ? 0 : 1; renderVotes(); });
dots.forEach((dot, index) => dot.addEventListener("click", () => { page = index; renderVotes(); }));
renderVotes();

function getReviewCardsPerView() {
  if (window.matchMedia("(min-width: 1120px)").matches) return 4;
  if (window.matchMedia("(min-width: 720px)").matches) return 2;
  return 1;
}

function setupReviewsSlideshow() {
  if (!reviewsTrack || !reviewCards.length || !reviewsDots) return;

  const getPageCount = () => Math.max(1, Math.ceil(reviewCards.length / getReviewCardsPerView()));

  function buildDots() {
    reviewsDots.innerHTML = "";
    for (let index = 0; index < getPageCount(); index += 1) {
      const dot = document.createElement("button");
      dot.type = "button";
      dot.addEventListener("click", () => {
        reviewPage = index;
        renderReviews();
        restartReviewsTimer();
      });
      reviewsDots.appendChild(dot);
    }
  }

  function renderReviews() {
    const perView = getReviewCardsPerView();
    const pageCount = getPageCount();
    reviewPage = Math.min(Math.max(reviewPage, 0), pageCount - 1);
    const gap = parseFloat(window.getComputedStyle(reviewsTrack).gap) || 0;
    const cardWidth = reviewCards[0].getBoundingClientRect().width;
    const offset = reviewPage * perView * (cardWidth + gap);
    reviewsTrack.style.transform = `translateX(-${offset}px)`;
    Array.from(reviewsDots.children).forEach((dot, index) => {
      dot.classList.toggle("is-active", index === reviewPage);
    });
  }

  function moveReviews(direction) {
    const pageCount = getPageCount();
    reviewPage = (reviewPage + direction + pageCount) % pageCount;
    renderReviews();
    restartReviewsTimer();
  }

  function restartReviewsTimer() {
    clearInterval(reviewsTimer);
    reviewsTimer = window.setInterval(() => moveReviews(1), 5200);
  }

  reviewsPrev?.addEventListener("click", () => moveReviews(-1));
  reviewsNext?.addEventListener("click", () => moveReviews(1));
  window.addEventListener("resize", () => {
    buildDots();
    renderReviews();
  });
  buildDots();
  renderReviews();
  restartReviewsTimer();
}

setupReviewsSlideshow();
